// 委外诉讼管理
var LawsuitManage = function () { return import('~/pages/outsource-manage/lawsuit-manage.vue'); };
var OutsourceLawsuitManage = function () { return import('~/pages/outsource-manage/outsource-lawsuit-manage.vue'); };
export default [
    {
        path: '/outer-stay/lawsuit-manage',
        name: 'lawsuit-manage',
        component: LawsuitManage
    },
    {
        path: '/outer-stay/outsource-lawsuit-manage',
        name: 'outsource-lawsuit-manage',
        component: OutsourceLawsuitManage
    }
];
